// extracted by mini-css-extract-plugin
export var actions = "_4j-0";
export var actionsContainer = "_4j-6";
export var border = "_4j-1";
export var childFullHeight = "_4j-d";
export var collapse = "_4j-2";
export var content = "_4j-8";
export var contentChild = "_4j-c";
export var fullscreen = "_4j-a";
export var headerContainer = "_4j-3";
export var headerRow = "_4j-5";
export var hidePadding = "_4j-9";
export var noScrollX = "_4j-e";
export var noScrollY = "_4j-f";
export var optOutTopPadding = "_4j-b";
export var pagePadding = "_4j-7";
export var profile = "_4j-g";
export var profileContainer = "_4j-h";
export var profileImage = "_4j-i";
export var profileMain = "_4j-j";
export var profileSubtitle = "_4j-l";
export var profileTitle = "_4j-k";
export var tabsWrapper = "_4j-4";
export var title = "_4j-m";